module.exports = __webpack_public_path__ + "static/media/bg-1.affd64fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/web/bg-1.png
// module id = 49
// module chunks = 3